"use client"
import React from "react";
import LocatorSearchResultCard from "@/components/locator/LocatorSearchResultCard";

import "@/components/locator/LocatorSearchResultPopout.css";
const LocatorSearchResultPopout = ({
  community,
  item,
  searchMode,
  selectedSearchOption,
  onClose
}) => {
  return (
    <>
      <div className="locator-search-result-popout-container">
        <div className="close-button" onClick={onClose}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="locator-search-result-popout-contents">
          <LocatorSearchResultCard
            community={community}
            item={item}
            searchMode={searchMode}
            selectedSearchOption={selectedSearchOption}
          />
        </div>
      </div>
    </>
  );
};

export default LocatorSearchResultPopout;
